import React, { useState, useEffect } from "react";
import axiosInstance from "../../../../services/AxiosInstance";
import VenueModal from "./venueModal";
import { Modal, Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import swal from "sweetalert";
import ZoneModal from "../zone/zonesModal";
import Select from "react-select";

const VenueList = ({
  fetchData,
  currPage,
  totalPage,
  setCurrPage,
  data = [],
  setData,
  setSearchQuery,
  searchQuery,
  cityList,
}) => {
  const [showVenueModal, setShowVenueModal] = useState(false);
  const [editData, setEditData] = useState(null);
  const [deleteId, setDeleteId] = useState(null);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showZoneModal, setShowZoneModal] = useState(false);
  const [venueOptions, setVenueOptions] = useState([]);
  const [selectedVenues, setSelectedVenues] = useState([]);
  const navigate = useNavigate();
  const itemsPerPage = 10;

  useEffect(() => {
    async function fetchVenues() {
      try {
        const response = await axiosInstance.get("/venue");
        const options = response.data.map((venue) => ({
          value: venue.id,
          label: venue.name,
        }));
        setVenueOptions(options);
        setData(response.data);
      } catch (error) {
        console.error("Error fetching venues:", error);
      }
    }
    fetchVenues();
  }, []);

  useEffect(() => {
    async function fetchVenues() {
      try {
        const response = await axiosInstance.get("/venue/list");
        const options = response.data.data.map((venue) => ({
          value: venue.id,
          label: venue.name,
        }));
        setVenueOptions(options);
        setData(response.data);
      } catch (error) {
        console.error("Error fetching venues:", error);
      }
    }
    fetchVenues();
  }, []);

  const handleVenueChange = (selectedOptions) => {
    if (selectedOptions.some((option) => option.value === "ALL")) {
      setSelectedVenues(venueOptions);
    } else {
      setSelectedVenues(selectedOptions);
    }
  };

  const handleDeleteModalShow = (id) => {
    setDeleteId(id);
    setShowDeleteModal(true);
  };

  const editVenue = (item) => {
    setEditData(item);
    setShowVenueModal(true);
  };

  const handleViewZones = (venueId) => {
    navigate(`/venue/${venueId}/zones`);
  };

  const handleDeleteVenue = async () => {
    try {
      await axiosInstance.delete(`/venue/${deleteId}`);
      setData((prevData) => prevData.filter((venue) => venue.id !== deleteId));
      setDeleteId(null);
      setShowDeleteModal(false);
      swal("Venue Deleted!", "", "success");
    } catch (error) {
      console.error("Error deleting venue:", error);
    }
  };

  const handlePreviousPage = () => {
    if (currPage > 1) setCurrPage((prev) => prev - 1);
  };

  const handleNextPage = () => {
    if (currPage < totalPage) setCurrPage((prev) => prev + 1);
  };

  return (
    <div className="col-12">
      <div className="card">
        <div className="card-body">
          <div className="w-100 table-responsive">
            <div className="d-flex justify-content-between align-items-center mb-3">
              <div className="d-flex" style={{ maxWidth: "300px" }}>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Search Venue Name"
                  onChange={(e) => setSearchQuery(e.target.value.toLowerCase())}
                  value={searchQuery}
                />
                <Button
                  variant="primary"
                  className="ms-2"
                  onClick={() => fetchData(searchQuery)}
                >
                  Search
                </Button>
              </div>
              <Button variant="success" onClick={() => setShowZoneModal(true)}>
                Add Common Zones
              </Button>
            </div>

            {showZoneModal && (
              <ZoneModal
                show={showZoneModal}
                handleClose={() => setShowZoneModal(false)}
                venueList={venueOptions}
                selectedVenues={selectedVenues} 
                setSelectedVenues={setSelectedVenues} 
                isCommonZone={true}
                additionalField={
                  <div className="mb-3">
                    <label>Select Venues</label>
                    <Select
                      isMulti
                      options={[
                        { label: "Select All", value: "ALL" },
                        ...venueOptions,
                      ]}
                      value={selectedVenues} 
                      onChange={(options) => {
                        if (options.some((option) => option.value === "ALL")) {
                          setSelectedVenues(venueOptions);
                        } else {
                          setSelectedVenues(options);
                        }
                      }}
                    />
                  </div>
                }
              />
            )}

            <table id="example" className="display w-100 dataTable">
              <thead>
                <tr>
                  <th>S. No.</th>
                  <th>Venue Code</th>
                  <th>Venue Name</th>
                  <th>Capacity</th>
                  <th>Venue Owner Name</th>
                  <th>Image</th>
                  <th>Edit</th>
                  <th>Show Zones</th>
                  <th>Delete</th>
                </tr>
              </thead>
              <tbody>
                {data.length ? (
                  data.map((item, index) => (
                    <tr key={item.id}>
                      <td>{(currPage - 1) * itemsPerPage + index + 1}</td>
                      <td>{item.venue_code}</td>
                      <td>{item.name}</td>
                      <td>{item.capacity}</td>
                      <td>{item.venue_owner_name}</td>
                      <td>
                        {item.imageURL ? (
                          <img
                            src={item.imageURL}
                            alt="Venue"
                            style={{
                              width: "50px",
                              height: "50px",
                              objectFit: "cover",
                              cursor: "pointer",
                            }}
                            onClick={() => window.open(item.imageURL, "_blank")}
                            onError={(e) => {
                              e.target.onerror = null;
                              e.target.outerHTML = "NA";
                            }}
                          />
                        ) : (
                          "NA"
                        )}
                      </td>
                      <td>
                        <i
                          className="fas fa-pen cursor-pointer"
                          onClick={() => editVenue(item)}
                        ></i>
                      </td>
                      <td>
                        <i
                          className="bi bi-eye-fill text-primary cursor-pointer"
                          onClick={() => navigate(`/venue/${item.id}/zones`)}
                        ></i>
                      </td>
                      <td>
                        <i
                          className="fas fa-trash text-danger cursor-pointer"
                          onClick={() => handleDeleteModalShow(item.id)}
                        ></i>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="9" className="text-center">
                      Data is not available
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
            <div className="pagination-controls d-flex align-items-center justify-content-center gap-2 mt-3">
              <Button
                variant="primary"
                disabled={currPage === 1}
                onClick={handlePreviousPage}
                className="px-3"
              >
                Previous
              </Button>
              {Array.from({ length: totalPage }, (_, i) => i + 1)
                .slice(
                  Math.max(currPage - 3, 0),
                  Math.min(currPage + 2, totalPage)
                )
                .map((page) => (
                  <Button
                    key={page}
                    variant={page === currPage ? "dark" : "light"}
                    className="px-3"
                    onClick={() => setCurrPage(page)}
                  >
                    {page}
                  </Button>
                ))}
              <Button
                variant="primary"
                disabled={currPage === totalPage}
                onClick={handleNextPage}
                className="px-3"
              >
                Next
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default VenueList;
